import * as React from "react";
import Text from "../../../../shared/components/text";
import * as styles from "./styles.css";
var ReviewEssential = function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(Text.Article, { className: styles.reviewBodyText }, children)));
};
export default ReviewEssential;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/review/reviewEssential.tsx
// module id = hTZP
// module chunks = 2